import './CSS_ke_log/CssForFIVEJS.css'
const Magnet = ()=> {

return(
    <div id="pncilwala">
      एक कोविड-19 वैक्सीन प्राप्त करने से आप चुंबकीय <span style={{color : "red"}}>नहीं </span>बनेंगे, जिसमें टीकाकरण की जगह भी शामिल है, जो आमतौर पर आपकी बांह होती है, क्योंकि वैक्सीन लौह, निकल, कोबाल्ट, लिथियम और दुर्लभ पृथ्वी मिश्र धातुओं जैसी धातुओं से मुक्त है। 
इसीलिए आप निश्चिंत रहिए आप कोविड-19 वैक्सीन से चुम्बकीय कभी भी नहीं होंगे ।

    </div>
);

}


export default Magnet;